import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="checkbox-updater"
// Handles checkbox updates that submit on change
export default class extends Controller {
  static values = {
    url: String,
    checkedUrl: String,    // URL to call when checked
    uncheckedUrl: String,  // URL to call when unchecked
    param: String,         // Parameter name if using single URL
    method: { type: String, default: 'PUT' }
  }

  connect() {
  }

  change(event) {
    const isChecked = event.target.checked

    // Determine which URL and method to use
    let url, method, data = {}
    if (this.hasCheckedUrlValue && this.hasUncheckedUrlValue) {
      // Use different URLs for checked/unchecked (like feature/unfeature)
      url = isChecked ? this.checkedUrlValue : this.uncheckedUrlValue
      method = 'POST'
    } else {
      // Use single URL with parameter
      url = this.urlValue
      method = this.methodValue

      if (this.hasParamValue) {
        data = this.buildNestedParams(this.paramValue, isChecked ? '1' : '0')
      }
    }

    fetch(url, {
      method: method,
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: Object.keys(data).length > 0 ? JSON.stringify(data) : null
    })
    .then(response => {
      if (response.ok) {
        this.showSuccess(event.target)
      } else {
        // Revert checkbox on error
        event.target.checked = !isChecked
        this.showError()
      }
    })
    .catch(error => {
      console.error('Update error:', error)
      event.target.checked = !isChecked
      this.showError()
    })
  }

  showSuccess(checkbox) {
    // Visual feedback
    const label = checkbox.closest('div')?.querySelector('label') || checkbox.parentElement
    if (label) {
      const originalBg = label.style.backgroundColor
      label.style.backgroundColor = '#d4edda'
      setTimeout(() => {
        label.style.backgroundColor = originalBg
      }, 1000)
    }
  }

  showError() {
    alert('There was an error that prevented this update.')
  }

  buildNestedParams(paramName, value) {
    // Parse parameter name like "master_recording[no_instrumental_available]"
    // into nested structure { master_recording: { no_instrumental_available: value } }
    const match = paramName.match(/^([^\[]+)\[([^\]]+)\]$/)

    if (match) {
      const [, parentKey, childKey] = match
      return { [parentKey]: { [childKey]: value } }
    } else {
      // Simple parameter without nesting
      return { [paramName]: value }
    }
  }
}
